export default __webpack_public_path__ + "static/media/credit.f7656e22.gif";